import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { fromResource } from 'store/selectors';

function SettingMenuDropdown({
  children = null,
  button = null,
  className = 'tv-setting-dropdown__element',
}) {
  const [showDropDown, setShowDropDown] = useState(false);
  const showDigitalIdInfo = useSelector(state =>
    fromResource.getDigitalIdInfo(state),
  );

  const toggleMenu = () => {
    setShowDropDown(!showDropDown);
  };

  const onBlur = event => {
    const { currentTarget } = event;
    event.preventDefault();
    event.stopPropagation();
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        // toggleMenu();
        setShowDropDown(false);
      }
    }, 250);
  };

  useEffect(() => {
    if (showDigitalIdInfo) {
      setTimeout(() => {
        setShowDropDown(false);
      }, 250);
    }
  }, [showDigitalIdInfo]);

  return (
    <div onBlur={onBlur} className={className}>
      <div
        role="button"
        tabIndex="-1"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          toggleMenu();
        }}
        onKeyDown={() => {}}
      >
        {button}
      </div>
      {showDropDown && children}
    </div>
  );
}

SettingMenuDropdown.propTypes = {
  children: PropTypes.node,
  button: PropTypes.node,
  className: PropTypes.string,
};

export default SettingMenuDropdown;
